import * as React from 'react';

const styles = require('./IconTile.module.scss');

interface IconTileProps {
    title1: string;
    icon: React.ReactNode;
    title2: string;
    subtitle: string;
}

export const IconTile = (props: IconTileProps) => {
    const { title1, icon, title2, subtitle } = props;

    return (
        <div className={styles.container}>
            <div className={styles.title1}>{title1}</div>
            <div className={styles.icon}>{icon}</div>
            <div className={styles.title2}>{title2}</div>
            <div className={styles.subtitle}>{subtitle}</div>
        </div>
    );
};
